<template>
  <transition
    name="fade"
    mode="out-in"
    enter-active-class="transition-opacity duration-500 ease-in-out"
    leave-active-class="transition-opacity duration-500 ease-in-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isLoading"
      class="absolute inset-0 z-10 flex flex-col items-center justify-center bg-primary bg-cover bg-center transition-opacity duration-500"
    >
      <div class="relative bottom-6 flex animate-pulse flex-col items-center gap-2">
        <img :src="logo" alt="Logo" class="w-1/2 max-w-[400px]" />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { LoadingKey } from '@/helpers/symbols'
import { inject, ref } from 'vue'

const loading = inject(LoadingKey)
const isLoading = loading?.get

const logo = ref(
  'https://s3-alpha-sig.figma.com/img/6cad/c5d3/40b6373010666ec45e2465b5001fc1a1?Expires=1730073600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Iq329lEgkXvmxWxeZIm-g6dzI4AvpJlQu0iR~eFuVLaRuBdQPw1Myqr0fRDLT046LUmQLmLszv0xGTmam44GGEQp5yAyoA05yft7KNVM50879J9XUGR2IDrRXxLJ1PFmFTOIqOiymansmspsYdXA8El7VaYF2HukmzRkJa6O1VzqiqNmcSukJVOgtuz6AHmq~9aHnpT7BIRSwit-xZN5WJiBT5tAF7SRD5gn2Jsc7DeIqGwbXMPNLSIIPAw-qM0ZG9gNiqGhnwwlAlq5BXhCXnYimrt8tYbHh0mbIpc3ZTjpiEfEK6vl6VwfR9FOugH-7u0jLSBliUPYHVerw9hv2w__'
)
</script>
